export const hasNoVolume = (props) => props.percentageOfOpenIdeas === 0 || props.percentageOfOpenIdeas === null;

export const calculateVolumeChangesBetween = (today, previousAverage) => {
    return today.map(sectorToday => {
        const previousAverageValues = previousAverage.find(sectorHistory => sectorHistory.name === sectorToday.name);
        if (previousAverageValues === undefined) {
            throw new Error(`Could not find historical average for ${sectorToday.name}`);
        }
        return {
            name:             sectorToday.name,
            volumeChange:     100 * ((sectorToday.percentageOfOpenIdeas - previousAverageValues.percentageOfOpenIdeas) / previousAverageValues.percentageOfOpenIdeas),
            sentimentChange:  (sectorToday.percentageLong !== null && previousAverageValues.percentageLong !== null) ? 100 * (sectorToday.percentageLong - previousAverageValues.percentageLong) : null,
            averageSentiment: previousAverageValues.percentageLong,
            currentSentiment: sectorToday.percentageLong,
            averageVolume:    previousAverageValues.percentageOfOpenIdeas * 100,
            currentVolume:    sectorToday.percentageOfOpenIdeas * 100
        };
    })
};